import _ from 'lodash'
import Enum from 'enum'

export const FontFamilies = new Enum({
  Arial: "Arial",
  TimesNewRoman: "Times New Roman",
  Helvetica: "Helvetica",
  Georgia: "Georgia",
  Brandon: "Brandon Text",
  Lato: "Lato",
  OpenSans: "Open Sans",
  Roboto: "Roboto",
  RobotoSlab: "Roboto Slab",
  Overpass: "Overpass",
})

export const FONT_FAMILY_OPTIONS = _.map(FontFamilies.enums, (font) => ({
  label: font.value,
  value: font.key,
}))

export default FontFamilies



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/OrgSettings/Constants.js